import I18n from 'I18n';
import { Select } from 'foundations-components/components/Select';
import { View } from 'foundations-components/components/View';
import { memo, useRef, useState } from 'react';
import { COMMON_HTTP_MESSAGES, DEBOUNCE_TIME } from '../../constants/Http';
import { objectTypes } from '../../constants/types';
import { formatContact } from '../../utils/objectFormatters';
import { jsx as _jsx } from "react/jsx-runtime";
function ContactSearch({
  selectContact,
  disabled,
  additionalFilters = {},
  appName,
  searchObjectApi
}) {
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const callbackRef = useRef();
  const loadOptions = ({
    input,
    callback
  }) => {
    if (isSelectOpen) {
      callbackRef.current = callback;
      searchObjectApi(Object.assign({
        query: input,
        after: '0',
        limit: 10
      }, additionalFilters, {
        objectType: objectTypes.contacts
      }), DEBOUNCE_TIME).then(res => {
        const options = res.results.map(formatContact);
        if (callbackRef.current) {
          callbackRef.current({
            options
          });
          callbackRef.current = undefined;
        } else {
          callback({
            options
          });
        }
      }).catch(err => {
        if (!err.message.includes(COMMON_HTTP_MESSAGES.REQUEST_ABORTED) && callbackRef.current) {
          callback({
            options: [],
            error: `${err.name} ${err.message}`
          });
        }
      });
    }
  };
  const handleValueChange = e => {
    selectContact(e.value);
  };
  const selectOpenHandler = value => {
    setIsSelectOpen(value);
  };
  return /*#__PURE__*/_jsx(View, {
    paddingInline: "0",
    marginBlockStart: "300",
    marginBlockEnd: "200",
    as: "div",
    children: /*#__PURE__*/_jsx(Select, {
      searchable: true,
      "data-test-id": `${appName}-participant-search-modal-select-input`,
      selectedItemsPlaceholder: I18n.text('contactList.searchPlaceholder'),
      disabled: disabled,
      loadAsyncOptions: loadOptions,
      onSelectedOptionChange: handleValueChange,
      onOpenChange: selectOpenHandler,
      clearable: true
    })
  });
}
export default /*#__PURE__*/memo(ContactSearch);